<template>
  <div class="py-2">
    <label for="{{forLabel}}" class="block text-sm font-medium text-gray-700">{{label}}</label>
    <div v-if="description" class="text-gray-500 text-xs">
      {{description}}
    </div>    
    <div class="mt-1">
      <input type="number" :value="value" :min="min" :max="max" @input="updateValue" class="defaultInput" :placeholder="placeholder" />
      <p v-if="error" class="mt-2 text-sm text-rose-600">{{error}}</p>
    </div>
  </div>
</template>

<script>

export default {
    name: 'InputNumber',
    props: {

        label: String,
        description: String,
        value: [String, Object, Boolean, Number],
        placeholder: String,
        min: {
            type: Number,
            default: 1,
        },
        max: {
            type: Number,
            default: 6,
        },
        error: String,
    },
    methods: {
        updateValue(event) {
            this.$emit('update:modelValue', event.target.value);
        },
        forLabel() {
            return this.label.replace(/\s/g, '').toLowerCase();
        },
    },
    created() {
      this.$emit('update:modelValue', this.value);
    },
}
</script>